const WHATSAPP_MESSAGE = `Hi, leuk dat je contact opneemt met A-WAVE. We helpen technische bedrijven met groeistrategie, marketing en events. Waar kunnen we je mee helpen?`;

export const WHATSAPP_URL = `https://wa.me/31641674914?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
